/**
 * Custom hook for offline data synchronization
 * Part of the FAANG-grade _app.tsx refactoring - Phase 2.3
 */

import { useEffect } from 'react';

import { startPeriodicSync } from '../utils/sync';

/**
 * Hook for managing offline data synchronization
 * Starts periodic background sync for quotes and services
 */
export const useOfflineSync = () => {
  // NOTE: No SSR guard before hooks — useEffect only runs on client.
  // An early return here would break React's rules of hooks (error #300).

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Start periodic offline sync (quotes/services)
    // Gentle cadence so E2E sees the flush after reconnect
    const syncIntervalId = startPeriodicSync(15000);

    // Cleanup interval on unmount
    return () => {
      if (syncIntervalId) {
        clearInterval(syncIntervalId as any);
        console.log('[OFFLINE_SYNC] Periodic sync stopped');
      }
    };
  }, []);
};
